module.exports = __webpack_public_path__ + "img/416f9cfaf39a0a00219a75200cc53f61.416f9cfa.png";